<template>
    <div class="p-4">
        <div id="product-details" v-if="project && project.id">
            <div class="row">
                <div class="col-md-12">
                    <div class="menu-bar clearfix">
                        <div id="project-info-menu-bar-title" class="pull-left"><h2>Project Info</h2></div>

                        <div class="dropdown pull-right" v-if="hasManagerPermission('projects.edit')">
                            <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
                                <template #button-content>
                                    <div class="icon icon-dim-32 icon-menu-red"></div>
                                </template>

                                <b-dropdown-item href="javascript:void(0)" v-b-modal.project-modal
                                                 v-on:click="backupProject">
                                    <b-icon-pencil></b-icon-pencil>&nbsp; Edit project info
                                </b-dropdown-item>
                                <!--                                 TODO: re-enable this when congrid must be enabled-->
                                <!--                                <b-dropdown-item href="javascript:void(0)" v-b-modal.congrid-modal>-->
                                <!--                                    <b-icon-house></b-icon-house>&nbsp;Congrid options-->
                                <!--                                </b-dropdown-item>-->
                            </b-dropdown>
                        </div>
                    </div>


                    <div class="row" id="project-options">
                        <div class="col-sm-10">
                            <div id="project-information-part">
                                <div class="row">
                                    <div class="col-sm-2">
                                        <p><strong>Name</strong></p>
                                    </div>
                                    <div class="col-sm-10">
                                        <p id="project-name-p">{{ project.name }}</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-2">
                                        <p><strong>Created</strong></p>
                                    </div>
                                    <div class="col-sm-10">
                                        <p>{{ $options.filters.moment(project.created_at, 'DD.MM.YYYY HH:mm') }}</p>
                                    </div>
                                </div>
                                <div class="row" v-if="project.created_by">
                                    <div class="col-sm-2">
                                        <p><strong>Creator</strong></p>
                                    </div>
                                    <div class="col-sm-10">
                                        <p>{{ project.created_by.name }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-2">
                                        <p><strong>Description</strong></p>
                                    </div>
                                    <div class="col-sm-10">
                                        <p>{{ project.description }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2 align-content-center">

                            <img id="project-dashboard-image_1" v-if="project.image"
                                 :src="project.image"
                                 class="img-fluid"
                                 alt="Image Not Available">
                            <div id="project-dashboard-image_2" v-else></div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div class="row">
                <div class="col-md-12">
                    <div class="menu-bar clearfix">
                        <div id="users-menu-bar-title" class="pull-left"><h2>Users</h2></div>

                        <div class="dropdown pull-right"
                             v-if="hasManagerPermission('projects.add_user') || hasManagerPermission('projects.delete_user')">
                            <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
                                <template #button-content>
                                    <div class="icon icon-dim-32 icon-menu-red"></div>
                                </template>

                                <b-dropdown-item href="javascript:void(0)"
                                                 v-b-modal.assign-users-modal
                                                 v-if="hasManagerPermission('projects.add_user')">
                                    <div class="icon icon-dim-24 icon-user-add-red"></div>
                                    Add users to project
                                </b-dropdown-item>

                                <b-dropdown-item href="javascript:void(0)"
                                                 v-b-modal.remove-users-modal
                                                 v-if="hasManagerPermission('projects.delete_user')"
                                >
                                    <div class="icon icon-dim-24 icon-user-remove-red"></div>
                                    Remove selected users
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>


                    <div class="col-md-8" v-if="project.assigned_users">
                        <ul class="list-unstyled" v-if="project.assigned_users.length > 0">
                            <li>
                                <ol class="selectable ui-selectable" style="z-index: 2;">
                                    <template v-for="user in project.assigned_users">
                                        <li
                                            @click="toggleSelectUser(user)"
                                            :class="{
                                            selected: selectedUsers.indexOf(user.id) > -1,
                                            'opacity-50': user.is_deleted
                                        }">
                                            <div class="grid-view-item-link" href="#">
                                                <div style="text-align: center; font-size: 20px;">
                                                    <b-icon icon="person-fill" size="lg"></b-icon>
                                                </div>
                                                <div class="grid-view-item-title">
                                                    {{ user.name }}
                                                </div>
                                            </div>
                                        </li>
                                    </template>
                                </ol>
                            </li>
                        </ul>

                        <h5 v-else>No users assigned to this project.</h5>
                    </div>
                </div>
            </div>

            <ProjectModal :project="project" v-on:setProject="resetProject"
                          v-on:projectSaved="projectSaved"></ProjectModal>
            <RemoveUsersModal :project="project" :users="selectedUsers" v-on:ok="updateProjectUsers"></RemoveUsersModal>
            <AssignUsersModal :project="project" v-on:ok="updateProjectUsers"></AssignUsersModal>
        </div>

        <congrid-modal></congrid-modal>

    </div>
</template>

<script>
import ProjectModal from "./parts/ProjectModal";
import RemoveUsersModal from "./parts/RemoveUsersModal";
import AssignUsersModal from "./parts/AssignUsersModal";
import CongridModal from "./parts/CongridModal";
import EventBus from '@js/eventBus';

export default {
    components: {CongridModal, AssignUsersModal, RemoveUsersModal, ProjectModal},
    data() {
        return {
            project: null,
            selectedUsers: [],
            originalProject: null,
            isRemoveUsersModalVisible: true,
            _onProjectLoaded: null,
        }
    },
    mounted() {
        this.project = this.$store.state.project;
        this.tryLoadUsers();

        this._onProjectLoaded = (project) => {
            this.project = project;
            this.tryLoadUsers();
        };
        EventBus.$on('project-loaded', this._onProjectLoaded);
    },
    beforeDestroy() {
        EventBus.$off('project-loaded', this._onProjectLoaded);
    },
    methods: {
        tryLoadUsers() {
            if (this.project && this.project.id && !this.project.assigned_users) {
                this.$store.dispatch('loadProjectUsers').then(users => {
                    this.$set(this.project, 'assigned_users', users);
                });
            }
        },
        toggleSelectUser(user) {
            this.isRemoveUsersModalVisible = false;
            const idx = this.selectedUsers.indexOf(user.id);
            if (idx === -1) {
                this.selectedUsers.push(user.id);
            } else {
                this.selectedUsers.splice(idx, 1);
            }
            this.isRemoveUsersModalVisible = true;
        },
        backupProject() {
            this.originalProject = Object.assign({}, this.project);
        },
        resetProject(project) {
            this.project = this.originalProject;
        },
        projectSaved(newProject) {
            this.project.image = newProject.image;
            this.$forceUpdate();
        },
        updateProjectUsers(users) {
            this.project.assigned_users = users;
            this.$forceUpdate();
            this.selectedUsers = [];
        },
    }
}
</script>
